<template>
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title class="headline"> Enviar E-mail </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email.to"
            label="Para"
            prepend-icon="mdi-email-outline"
            :rules="[
              (v) => !v || /.+@.+\..+/.test(v) || 'O Email deve ser válido',
            ]"
          />

          <v-text-field
            v-model="email.cc"
            label="CC"
            prepend-icon="mdi-account-multiple-outline"
            :rules="[
              (v) => !v || /.+@.+\..+/.test(v) || 'O Email deve ser válido',
            ]"
          />
          
          <v-text-field
            v-model="email.bcc"
            label="CCO"
            prepend-icon="mdi-email-outline"
            :rules="[
              (v) => !v || /.+@.+\..+/.test(v) || 'O Email deve ser válido',
            ]"
          />
          <v-text-field
            v-model="email.subject"
            label="Assunto"
            prepend-icon="mdi-text-box-outline"
            :rules="[(v) => !!v || 'O campo Assunto é obrigatório']"
          />
          <v-textarea
            v-model="email.body"
            label="Mensagem"
            auto-grow
            rows="4"
            prepend-icon="mdi-pencil"
            :rules="[(v) => !!v || 'O campo Mensagem é obrigatório']"
          />

          <!--<v-file-input
            :value="attachedFile"
            label="Anexo (PDF)"
            prepend-icon="mdi-paperclip"
            readonly
            dense
          >
          </v-file-input>-->
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Cancelar</v-btn>
        <v-btn color="primary" @click="sendEmail">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { integer } from "vuelidate/lib/validators";

export default {
  name: "EmailComposer",
  props: {
    show: Boolean,
    fornecedorEmail: String, // Preenche o campo "De"
    numeroPedido: Number,
  },
  data() {
    return {
      valid: false,
      html: null,
      email: {
        from: "",
        to: this.fornecedorEmail || "",
        cc: "",
        bcc: "",
        subject: "",
        body: "",
      },
      emailDestinatarios: [], // v-model do combobox
      opcoesEmail: [], // e-mails disponíveis
      emailRule: (v) => !!v || "O campo 'Para' é obrigatório.",
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.prepararEmails();
      }
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    prepararEmails() {
      this.email.subject = "Pedido Nº " + this.numeroPedido;
    },
    sendEmail() {
      if (!this.$refs.form.validate()) return;

      const fornecedores = this.emailDestinatarios.join(",");

      if (this.email.to != "" || this.email.cc != ""  || fornecedores != "") {
        const formData = new FormData();
        formData.append("from", this.email.from);
        formData.append("to", this.email.to);
        formData.append("cc", this.email.cc);
        formData.append("bcc", this.email.bcc);
        formData.append("subject", this.email.subject);
        formData.append("body", this.email.body);

        if (this.attachedFile && this.attachedFile.blob) {
          formData.append(
            "attachment",
            this.attachedFile.blob,
            this.attachedFile.name
          );
        }
        this.$emit("send", formData);
        this.$emit("cancel");
      } else {
        this.$alert(
          "Informe um endereço de email para envio!",
          "Atenção!",
          "warning"
        );
      }
    },
  },
};
</script>
